import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { Grid } from '@material-ui/core';
import { useTranslation } from '../../../../src/i18n';
import FormikCheckbox from '../../../../components/Fields/CheckboxField/FormikCheckbox';
import Title from '../../../../components/Title';
import { PERFORMANCE_TYPES_ID, TP } from '../../../../constants/consts';
import { IS_CO_PRODUCED } from '../../../../constants/formFields';
import { EDITING_PRODUCTION_ENTITY_TYPES } from '../../constants';

const groupesOfProductionTypes = {
  loneTypes: [
    PERFORMANCE_TYPES_ID.NATIONAL_PREMIERE,
    PERFORMANCE_TYPES_ID.WORLD_PREMIERE,
    PERFORMANCE_TYPES_ID.NEW_PRODUCTION,
  ],
  coproducedTypes: [PERFORMANCE_TYPES_ID.FESTIVAL, IS_CO_PRODUCED],
  multiTypes: [PERFORMANCE_TYPES_ID.CONCERT, PERFORMANCE_TYPES_ID.RECITAL],
  videoTypes: [PERFORMANCE_TYPES_ID.LIVESTREAM, PERFORMANCE_TYPES_ID.VIDEO_ON_DEMAND],
};

const TypesEditFields = ({ productionTypesField, type }) => {
  const { t } = useTranslation();

  return (
    <>
      <Title size="big" style={{ fontWeight: 'bold' }}>
        {t(`${TP}.FN_PRODUCTION_TYPE`)}
      </Title>
      <Grid container spacing={2}>
        {Object.values(groupesOfProductionTypes).map((group, index) => (
          <Grid item md={3} sm={6} xs={12} key={`typesGroup-${index}`}>
            {group?.map(typeKey => {
              const prodType = productionTypesField.value[typeKey];
              return (
                <Field
                  key={prodType?.label}
                  name={`${productionTypesField.name}.${typeKey}`}
                  label={t(prodType?.label)}
                  component={FormikCheckbox}
                  isDisabled={
                    type === EDITING_PRODUCTION_ENTITY_TYPES.FESTIVAL && typeKey === PERFORMANCE_TYPES_ID.FESTIVAL
                  }
                />
              );
            })}
          </Grid>
        ))}
      </Grid>
    </>
  );
};

TypesEditFields.propTypes = {
  productionTypesField: PropTypes.object.isRequired,
  type: PropTypes.oneOf(Object.values(EDITING_PRODUCTION_ENTITY_TYPES)),
};

export default memo(TypesEditFields);
